const SUPPORTED_THEMES = {
    DARK: 'dark',
    LIGHT: 'light'
}

export default SUPPORTED_THEMES